import { Card, CardHeader, CardBody } from 'reactstrap'
import AppObjectHistoryTable from '../AppObjectHistoryTable/AppObjectHistoryTable'

export default function AppObjectHistoryCard({ history }) {
  console.log('AppObjectHistoryCard rendered')

  return (
    <Card className="app-object-card">
      <CardHeader className="app-object-card-header" data-cy='app-object-card-header'>History</CardHeader>
      <CardBody className="app-object-card-body">
        <AppObjectHistoryTable history={history} />
      </CardBody>
    </Card>
  )
}